import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';
import Employee from 'main/stores/employees/Employee';
import _ from 'lodash';

class TerminatedEmployeeDataSource {
  store = new DomainStore();

  async load() {
    await this.store._compose([
      endpoints.EMPLOYEES.TERMINATED
    ]);

    return this.store.getAllOrdered(types.EMPLOYEE, Employee);
  }
}

export default TerminatedEmployeeDataSource;
